import { render, staticRenderFns } from "./goodsHome.vue?vue&type=template&id=323f0225&scoped=true&"
import script from "./goodsHome.vue?vue&type=script&lang=js&"
export * from "./goodsHome.vue?vue&type=script&lang=js&"
import style0 from "./goodsHome.vue?vue&type=style&index=0&id=323f0225&lang=scss&scoped=true&"
import style1 from "./goodsHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323f0225",
  null
  
)

export default component.exports